import React, { useEffect, useState } from "react";
import {
  I2cInput,
  I2cRadio,
  I2cRadioGroup,
  I2cPhoneField,
  I2cListItem,
  I2cCheckboxGroup,
  I2cCheckbox,
} from "@webcomponents/i2cwebcomponents/dist/react";
import "../Prepaid.scss";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import ErrorMessage from "../../../Components/SharedComponent/ErrorMessage/ErrorMessage";
import { validationSchemaProgramManagementService } from "./validationScheme";
export const programMngt = [
  { label: "Managed by i2c inc.", value: 0 },
  { label: "Managed by Sponsor Bank/Issuer/ISO", value: 1 },
  { label: "Other", value: 2 },
  { label: "N/A", value: 3 },
];
export const otherServices = [
  { label: "Mobile Text Messaging (short code required)", value: 0 },
  { label: "Bill Payment", value: 1 },
  { label: "Communication Manager", value: 2 },
  { label: "Transaction (service) Coupons", value: 3 },
  { label: "Rewards", value: 4 },
  { label: "i-Coupons", value: 5 },
  { label: "Other", value: 6 },

];
const ProgramManagementServices = ({
  type,
  setAddFormData,
  addFormData,
  setFormValidStates,
  formDataJson,
  isFetching,
}) => {
  const [selectedOtherServices, setSelectedOtherServices] = useState([]);
  const [selectedServicesValues, setServicesCheckboxValues] = useState({
    asObject: "Null",
  });

 
  const handleOtherServices = (event) => {
    const selectedServicesType = event.target?.inputValue || [];
    setSelectedOtherServices(selectedServicesType);
    setServicesCheckboxValues({
      asObject: JSON.stringify({ digits: selectedServicesType }),
    });
  };
  // Initialize React Hook Form with Yup resolver
  const methods = useForm({
    resolver: yupResolver(validationSchemaProgramManagementService),
    mode: "all",
    reValidateMode: "onChange",
    shouldUseNativeValidation: false,
    criteriaMode: "firstError",
    defaultValues: {
      of_pms_processor: "",
      of_pms_company_name: "",
      of_pms_contact_name: "",
      of_pms_job_title: "",
      of_pms_phone_number: "",
      of_pms_country: "",
      of_pms_email: "", 
    },
  });

  // Controlls destructuring from the method
  const {
    control,
    formState: { errors },
  } = methods;

  const fields = [
    "of_pms_processor",
    "of_pms_company_name",
    "of_pms_contact_name",
    "of_pms_job_title",
    "of_pms_phone_number",
    "of_pms_country",
    "of_pms_email",  
  ];
  useEffect(() => {
    if (!isFetching && Object.keys(formDataJson ?? {}).length) {
      fields.forEach((field) => {
        methods.setValue(field, formDataJson[4]["4_2"][field] ?? "");
      });
      /*  methods.setValue("of_pms_other_services", []); */
      methods.trigger();
    }
  }, [isFetching]);

  // Trigger validation when component mounts
  React.useEffect(() => {
    methods.trigger();
  }, []);

  const handleValueChanges = () => {
    const values = methods.getValues();
    setAddFormData({
      ...addFormData,
      4: {
        ...addFormData["4"],
        "4_2": { ...values },
      },
    });
  };

  // Update form validation state when errors change
  React.useEffect(() => {
    const errorsLength = Object.keys(errors).length;
    if (errorsLength === 0) setFormValidStates("4_2", true);
    else setFormValidStates("4_2", false);
    handleValueChanges();
  }, [Object.keys(errors).length]);

  return (
    <React.Fragment>
      <div className="forms-instance">
        <div i2c-grid="grid gap-sm" className="section-space">
          <div i2c-grid="12">
            <div className="single-field-wrapper">
              <Controller
                name="of_pms_processor"
                control={control}
                render={({ field }) => (
                  <I2cRadioGroup
                    value={methods.watch("of_pms_processor")}
                    {...field}
                    name="of_pms_processor"
                    onI2cChange={(e) => {
                      [
                        "of_pms_company_name",
                        "of_pms_contact_name",
                        "of_pms_job_title",
                        "of_pms_phone_number",
                        "of_pms_country",
                        "of_pms_email",
                      ].map((field) => methods.setValue(field, ""));
                      field.onChange(e);
                      methods.trigger();
                    }}
                  >
                    <div i2c-grid="grid gap-sm">
                      {programMngt.map((radio, index) => (
                        <I2cListItem
                          key={index}
                          i2c-grid="4@md"
                          variant="receipt"
                          label={radio.label}
                          checked={
                            methods.watch("of_pms_processor") === radio.value
                          }
                          sublabel=""
                          value=""
                          type="checkbox"
                        >
                          <I2cRadio
                            checked={
                              methods.watch("of_pms_processor") === radio.value
                            }
                            slot="prefix"
                            filled
                            name="of_pms"
                            value={radio.value}
                          >
                            {" "}
                          </I2cRadio>
                        </I2cListItem>
                      ))}
                    </div>
                  </I2cRadioGroup>
                )}
              />
            </div>
          </div>
          {methods.watch("of_pms_processor") === 2 && (
            <div i2c-grid="12">
              <div className="custom-label-light mb-12">
                If using a 3rd Party Vendor, please provide details
              </div>
              <div i2c-grid="grid gap-column-sm gap-row-md">
                <div i2c-grid="4@md ">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_pms_company_name"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          label="Company Name"
                          placeholder="Enter Company Name"
                          name={"of_pms_company_name"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_pms_company_name &&
                        methods.formState.touchedFields.of_pms_company_name
                          ? true
                          : false
                      }
                      message={
                        errors.of_pms_company_name?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="4@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_pms_contact_name"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          label="Contact Name"
                          placeholder="Enter Contact Name"
                          name={"of_pms_contact_name"}
                        />
                      )}
                    />
                    <ErrorMessage
                      show={
                        errors.of_pms_contact_name &&
                          methods.formState.touchedFields.of_pms_contact_name
                          ? true
                          : false
                      }
                      message={
                        errors.of_pms_contact_name?.message ?? "Invalid input"
                      }
                    />
                  </div>
                </div>
                <div i2c-grid="4@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_pms_job_title"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          size="large"
                          label="Title"

                          placeholder="Enter Title"
                          name={"of_pms_job_title"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_pms_job_title &&
                        methods.formState.touchedFields.of_pms_job_title
                          ? true
                          : false
                      }
                      message={
                        errors.of_pms_job_title?.message ?? "Invalid input"
                      }
                    /> */}
                  </div>
                </div>
                <div i2c-grid="4@md">
                  <div className="single-field-wrapper">
                    <I2cPhoneField
                      format="NATIONAL"
                      label="Company Phone "
                      tooltip-help="Custom Text"
                      name="ci_companyName"
                      size="large"
                      country-box
                      show-flags
                      selectedCountry={methods.watch("of_pms_country") || "US"}
                      value={methods.watch("of_pms_phone_number")}
                      errorMessageVisible={false}

                      onI2cChange={(e) => {
                        const country = e.target.country;
                        const isValid = e.target.isValid;
                        const value = e.target.value;
                        methods.setValue("of_pms_country", country);
                        methods.setValue("of_pms_phone_number", value);
                        handleValueChanges();
                        if (!isValid) {
                          methods.setError("of_pms_phone_number", {
                            message: e.target.guide,
                          });
                        } else {
                          methods.clearErrors("of_pms_phone_number");
                        }
                      }}
                    />
                    {/* <ErrorMessage
												show={
													errors.of_pms_phone_number &&
													methods.formState.touchedFields.of_pms_phone_number
														? true
														: false
												}
												message={
													errors.of_pms_phone_number?.message ?? "Invalid input"
												}
											/> */}
                  </div>
                </div>
                <div i2c-grid="4@md">
                  <div className="single-field-wrapper">
                    <Controller
                      name="of_pms_email"
                      control={control}
                      render={({ field }) => (
                        <I2cInput
                          {...field}
                          className="single-input-field"
                          onI2cInput={(e) => {
                            const value = e.target.value;
                            field.onChange(value);
                            handleValueChanges();
                          }}
                          type="email"
                          size="large"
                          label="Email"

                          placeholder="Enter Email"
                          name={"of_pms_email"}
                        />
                      )}
                    />
                    {/* <ErrorMessage
                      show={
                        errors.of_pms_email &&
                        methods.formState.touchedFields.of_pms_email
                          ? true
                          : false
                      }
                      message={errors.of_pms_email?.message ?? "Invalid input"}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      
  
      </div>
    </React.Fragment>
  );
};

export default ProgramManagementServices;
